import FinanceZohoClientDetails from '../Finance/ZohoClientDetails/zohoClientDetails';

export default FinanceZohoClientDetails;
